import { createElement, FC } from 'react';
import { matchPath, Outlet, useLocation } from 'react-router-dom';
import rtlDetect from 'rtl-detect';
import { ToastContainer } from '@ebsco-ui/ebsco-ui';

import { Footer } from '@app/components';
import { useAppContext } from '@app/contexts';
import { ROUTE } from '@app/constants';

import { Header } from './Header';
import { BackToTopButton } from './BackToTopButton';

import css from './NavigationLayout.module.scss';

export const NavigationLayout: FC = () => {
  const { locale } = useAppContext();
  const { pathname } = useLocation();

  const isAdvancedSearchRoute = pathname === ROUTE.advancedSearch;

  const getMainWrapper = () => {
    const isSearchResultsPage = pathname === ROUTE.search;
    const isInstanceDetailsPage = Boolean(
      matchPath(ROUTE.instanceDetails, pathname)
    );

    return createElement(
      isSearchResultsPage || isInstanceDetailsPage ? 'div' : 'main',
      {
        className: css.mainWrapper,
        'data-focus': 'focusedNode',
        tabIndex: -1,
      },
      <Outlet />
    );
  };

  return (
    <>
      <Header isSearchVisible={!isAdvancedSearchRoute} />
      {getMainWrapper()}
      <div className={css.pageButtonsWrapper}>
        <BackToTopButton />
      </div>
      {!isAdvancedSearchRoute && <Footer />}
      <ToastContainer rtl={rtlDetect.isRtlLang(locale)} />
    </>
  );
};
